import React from "react";

import Multimedia from "../components/multimedia/multimedia";

const getCountryFlagUrl = (country = {}, type) => {
  const extension = type === "small" ? "PNG" : "svg"
  return `https://cdn.bystadium.com/flags/${type}/${country.iso}.${extension}`;
}

interface CountryProps {
  name: string;
  iso: string;
}

interface CountryFlagProps {
  country: CountryProps;
  type: string;
}

const CountryFlag = ({ country, type="small" }: CountryFlagProps) =>
  country?.name ? (
    <Multimedia
      type="image"
      isNextImage={false}
      displayLoader
      src={getCountryFlagUrl(country, type)}
      alt={`${country.name} Flag`}
      width= {24}
      height={24}
      className='country-flag'
    />
  ) : (
    ""
  );

export default CountryFlag;
